<div class="flex flex-col h-full">
  <!-- Scrollable area -->
  <div>

    @if (collapsed) {
      <ng-container *ngTemplateOutlet="conversationList; context: {
      $implicit: conversationService.conversationHistory(),
      scrollHeight: 'calc(100vh - 133px - .5rem)'
    }"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="conversationList; context: {
      $implicit: conversationService.conversationHistory(),
      scrollHeight: 'calc(100vh - 170px - .5rem)'
    }"></ng-container>
    }
  </div>

  <!-- Footer -->
  <div class="flex items-center justify-center border-t-2 border-surface-200 pt-2">
    <button (click)="routeTo()">
      <i
        class="pi pi-home mr-2"
        aria-label="Return to My Clients"
        [pTooltip]="collapsed ? 'Return to My Clients' : undefined"
        tooltipPosition="top"
      ></i>
      @if (!collapsed) {Return to My Clients}
      </button>
    </div>
  </div>

  <!-- Shared Conversation Info List Template -->
  <ng-template #conversationList let-conversations let-scrollHeight="scrollHeight">
    @if (!collapsed) {<div class="py-2 px-2 text-sm font-medium text-surface-600">Searched Conversations</div>}
    <bds-scroll-region
      styleClass="pb-2"
      [height]="scrollHeight"
      ariaLabel="Searched conversations"
    >
      @if (conversations.length > 0) {
        <div class="bds-list-stack">
          @for (conversation of conversations; track trackByConversationId($index, conversation)) {
            <div
              [attr.data-conversation]="conversation.conversationId"
              tabindex="-1"
            >
              <lib-conversation-info
                [conversationInfo]="conversation"
                [selected]="conversation.conversationId === conversationService.activeConversation()?.conversationId"
                [collapsed]="collapsed"
                (conversationClicked)="selectConversation($event)"
              />
            </div>
          }
        </div>
      } @else if (!collapsed) {
        <div class="flex items-center justify-center">No searched conversations</div>
      }
    </bds-scroll-region>
  </ng-template>
